
export const environment = {
  production: process.env.PRODUCTION || false,
  apiURL: process.env.APIURL || '',
  recaptchaToken: process.env.RECAPTCHTOKEN || ''
};
